'use strict';

function parameterFactory(appSettings, dataRequestService, parameterNames) {
  let parameters = {};

  return {
    initParameters: function(cdSystem) {
      const keys = Object.keys(parameterNames).map(function(key) {
        return parameterNames[key];
      });
      return dataRequestService.getParameters(keys, cdSystem).then(function(data) {
        parameters = data;
      }, function(e) {
        console.error('parameters not initialized:', e);
      });
    },
    getParameter:    function(key) {
      return parameters[key.toUpperCase()];
    }
  };

}

parameterFactory.$inject = ['appSettings', 'dataRequestService', 'parameterNames'];
export default parameterFactory;



// WEBPACK FOOTER //
// ./src/app/scripts/factories/parameterFactory.js